import React, { Component } from "react";
import "../Styles/Popup.css";
import ButtonContainer from "./ButtonContainer";
import COLORS from "../Colors";
import * as Constants from "../Utilities/Constants";

/*let Q_NAMES = Constants.Q_NAMES;
const Q_ORDER = [
  Q_NAMES.FIRST_NAME,
  Q_NAMES.LAST_NAME,
  Q_NAMES.BIRTHDAY,
  Q_NAMES.SELF_CONCERN,
  Q_NAMES.OTHER_CONCERN,
  Q_NAMES.HIGH_SCHOOL,
  Q_NAMES.HEIGHT,
  Q_NAMES.WEIGHT,
  Q_NAMES.DIABETES,
  Q_NAMES.STROKE,
  Q_NAMES.HELP,
  Q_NAMES.ANTIDEPRESSANTS,
  Q_NAMES.EFFORT,
];*/ 
export default class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateIndex) {
      this.props.updateIndex(this.state.index);
    }

    if (prevProps.questionIdx !== this.props.questionIdx) {
      this.openNav();
      this.setState({
        index: 0,
      });
    }
  }
  /*prev_question = (question) => {
    let curr_q_name = Q_ORDER[this.state.question_num];
    console.log("question index RN!!! " , this.props.questionIdx);
    let prev_q_name = Q_ORDER[12];
    console.log("prev q name: " , prev_q_name);
    console.log("are answers in this session???? ");
    console.log(sessionStorage.getItem("answers"));
    let new_answers = JSON.parse(sessionStorage.getItem("answers"));
    // Deleting prev question answers
    console.log("new_answers!!!:  ");
    console.log(new_answers);
    console.log("new_answers[prev_q_name]: " + new_answers[prev_q_name]);
    new_answers[prev_q_name] = "";
    console.log("answers AFTER erase: !!!!!!");
    console.log(new_answers);

    //skip to the test section if the users
    //answer indicates this is necessary
    //RECOMMENT THIS IN DURING REAL
    // if(question['skip_answer'] && question['skip_answer'].includes(curr_answer)){
    //   this.props.history.push({
    //     pathname: Constants.PATH_NAMES.TEST
    //   })
    // }

    //Check to see whether there are prev
    //questions
      sessionStorage.setItem("questionnaireIdx", 12 - 1);

      let new_question_num = 12 - 1;

      this.reset_state(new_question_num, new_answers);
      sessionStorage.setItem("answers", JSON.stringify(new_answers));
  }; */

  updatePopup = () => {
    if (this.state.index < this.props.popup_text.length - 1) {
      this.setState({
        index: this.state.index + 1,
      });
    } else {
      this.closeNav();
    }
  };

  openNav = () => {
    document.getElementById("popup").hidden = false;
    document.getElementById("overlay").hidden = false;
    document.getElementById("popup").style.height = "73%";
  };

  /* Set the width of the side navigation to 0 */
  closeNav = () => {
    document.getElementById("overlay").hidden = true;
    document.getElementById("popup").style.height = "0%";
  };

  render() {
    let confirm_text = this.props.confirmation_text
      ? this.props.confirmation_text[this.state.index]
      : "Tap here to continue";
    /*  console.log("this.props.previous_text: " , this.props.previous_text);
    let prevText = this.props.previous_text ? this.props.previous_text[0]
    : "Tap here previous"; */

    return (
      <div style={{ display: this.props.hidden ? "none" : "inline" }}>
        <div className="overlay" id="overlay" />
        <div className="popup" id="popup">
          <div className="content">
            {this.props.popup_text[this.state.index]}
            <ButtonContainer
              colors={[COLORS.blue]}
              buttonTexts={[confirm_text]}
              buttonType="filled"
              onClick={() => {
                if (
                  this.state.index === this.props.popup_text.length - 1 &&
                  this.props.callback
                ) {
                  this.props.callback();
                }
                this.updatePopup();
              }}
            />

           
          </div>
        </div>
      </div>
    );
  }
}
